import blogFetch from "../axios/config.js";
import { user, password } from "../utils/constantes.js";
import {  setCookie } from "../section/cookie.js";

const getToken = async () => {
  try {
    const userData = {
      USR_userName: user,
      USR_password: password,
    };
    
    const response = await blogFetch.post("/token", userData);
    let token = response.data.token;
    localStorage.setItem("user", JSON.stringify(response.data));

    //Seta userId para futuras requisições como pegar pemissões.
    setCookie("userId", response.data.user_Id, 7);
    return token;
  } catch (error) {
    console.error(error);
    return null;
  }
};

export default getToken;
